import {updateInitWidthContainer} from './layout';

$( function() {
	$( '.share-location-container' ).each( function() {
		var $shareLocationContainer = $( this );
		var $shareLocationLink = $shareLocationContainer.find( '.share-location-link' );
		var $shareLocationError = $shareLocationContainer.find( '.share-location-error' );
		if ( navigator.geolocation ) {
			$shareLocationLink.click( function( e ) {
				e.preventDefault();
				navigator.geolocation.getCurrentPosition( function( position ) {
					$( '#clinic-filtering-search-input' ).val( '' );
					$( '.filtering-filter[data-filter-type="all"]' ).each( function() {
						this.click();
					} );

					var coords = position.coords;
					$( '.clinic-finder-clinic, .filtering-clinic-finder-clinic' ).toArray()
						.map( function( clinicElement ) {
							return {
								$element: $( clinicElement ),
								element: clinicElement,
								distance: getDistanceFromLatLonInKm(
									coords.latitude, coords.longitude,
									parseFloat( clinicElement.getAttribute( 'data-coord-lat' ) ),
									parseFloat( clinicElement.getAttribute( 'data-coord-lng' ) ),
								),
							};
						} )
						.filter( function( item ) {
							item.$element.addClass( 'hidden' );
							return true;
						} )
						.sort( function( a, b ) {
							return a.distance - b.distance;
						} )
						.slice( 0, 3 )
						.forEach( function( item, index ) {
							item.$element.removeClass( 'hidden' );
						} );
					updateSelectedClinicLabel();
					$shareLocationError
						.removeClass( 'visible' )
						.addClass( 'invisible' );
					$( '#clinic-search-input' ).val( '' );
				}, function( error ) {
					$shareLocationError
						.removeClass( 'invisible' )
						.addClass( 'visible' );
				} );
			} );
		} else {
			$shareLocationLink.click( function( e ) {
				e.preventDefault();
				$shareLocationError
					.removeClass( 'invisible' )
					.addClass( 'visible' );
			} );
		}
	} )
} );

function getDistanceFromLatLonInKm( lat1, lon1, lat2, lon2 ) {
	var R = 6371; // Radius of the earth in km
	var dLat = deg2rad( lat2 - lat1 );  // deg2rad below
	var dLon = deg2rad( lon2 - lon1 );
	var a =
		Math.sin( dLat / 2 ) * Math.sin( dLat / 2 ) +
		Math.cos( deg2rad( lat1 ) ) * Math.cos( deg2rad( lat2 ) ) *
		Math.sin( dLon / 2 ) * Math.sin( dLon / 2 )
	;
	var c = 2 * Math.atan2( Math.sqrt( a ), Math.sqrt( 1 - a ) );
	var d = R * c; // Distance in km
	return d;
}

function deg2rad( deg ) {
	return deg * (Math.PI / 180)
}

$( function() {
	$( '#myTab2Content a' ).on( 'click', function( e ) {
		e.preventDefault();
		$( '#collapseOne' ).collapse( 'toggle' );
		$( '.clinic-finder-clinic' )
			.addClass( 'hidden' )
			.filter( '[data-id="' + this.getAttribute( 'data-clinic-target-id' ) + '"]' )
			.removeClass( 'hidden' );
		updateSelectedClinicLabel();
		$( '#clinic-search-input' ).val( '' );
	} )
} );

$( function() {
	$( '#clinic-search-input' ).keyup( searchClinic );
	$( '#clinic-search-button' ).click( function( e ) {
		e.preventDefault();
		searchClinic();
	} );

	function searchClinic() {
		var escapedSearchString = esc_title( $( '#clinic-search-input' ).val() );
		var $clinics = $( '.clinic-finder-clinic' ).addClass( 'hidden' );
		if ( escapedSearchString.trim() !== '' ) {
			$clinics.filter( function( index, element ) {
				var content = esc_title( $( element ).find( '.title' ).text() ) + esc_title( $( element ).find( '.address' ).text() );
				return content.indexOf( escapedSearchString ) >= 0;
			} ).removeClass( 'hidden' );
			updateSelectedClinicLabel();
		}
	}
} );

export function esc_title( string ) {
	if ( string === undefined ) {
		return string;
	}
	string = string.toLowerCase().replace( /[áàâå]/g, 'a' )
		.replace( /[ø]/g, 'o' )
		.replace( /[úùû]/g, 'u' )
		.replace( /[äæ]/g, 'ae' )
		.replace( /[ö]/g, 'oe' )
		.replace( /[ü]/g, 'ue' )
		.replace( /[ß]/g, 'ss' )
		.replace( /[éèë]/g, 'e' )
		.replace( /[í]/g, 'i' );
	return string.replace( /[^0-9a-z]/gi, '' );
}

function updateSelectedClinicLabel() {
	$( '.clinic-finder-clinic' )
		.filter( function() {
			return $( this ).is( ":visible" );
		} )
		.find( '.selected-clinic-label' )
		.each( function( index ) {
			$( this ).css( 'visibility', (index === 0) ? 'visible' : 'hidden' );
		} );

	updateInitWidthContainer();
}
